export default (string)=>
{
  let messages = {
    "error.request500":"Request failed with status code 500",
    "error.addedTheFeedback":"Successfully added the feedback for the provider.",
"error.statusNotAvailable":"Status is not available for the bill yet.",
"error.fovoritesNotExist":"Favorites does not exist for the user.",
"error.clientGroupId":"clientGroupId should not be empty",
"error.clientId":"clientId should not be empty",
"error.distanceShouldNotEmpty":"distance should not be empty",
"error.orgDistance":"orgDistance should not be empty",
"error.postalCode":"postalCode should not be empty",
"error.npi":"npi should not be empty",
"error.user":"User does not exists",
"error.contactInformation":"Failed to update the contact information.",
"error.successfullyUpdatedUser":"Successfully updated User contact information.",
"error.patientId":"Patient Id is missing",
"error.patientIdNotEmpty":"patientId should not be empty",
"error.successfullyAdded":"Successfully added the procedure shopper survey.",
"error.procedure":"Procedure does not exist",
"error.failedToAdd":"Failed to add the procedure.",
"error.thereIsAnError":"There is an error occured",
"error.invalidPostalCode":"Invalid postal code.",
"error.scoreRange":"Score Range must be number",
"error.providerId":"providerId should not be empty",
"error.faildToAddProvider":"Failed to add the provider to the favorite list.",
"error.alreadyAddedProvider":"Already added this provider as favorite",
"error.couldNotAddProvider":"Could not add the provider, as the provider already exists in the favorite list of the user.",
"error.providerNotExist":"The provider does not exist.",
"error.faildToAddFeedback":"Failed to add feedback for the provider",
"error.deviceToken":"device_token should not be empty",
"error.faildToRegister":"Failed to register the device to receive the notifications",
"error.deviceSuccessfullyRegister":"Your device has successfully register to receive the notifications",
"error.noDeviceAssociated":"No device has associated with the information provided",
"error.networkError":"Network Error",
"error.networkErrorText":"Your request can not be processed at this time.",
"error.networkErrorText1":"Please try again after sometime.",
"error.networkErrorText2":"An unknown error has occurred.",
"error.deviceSuccessfullyDeRegister":"Your device has successfully de-register from receiving the notifications"}

  let vals = Object.values( messages )
   let index = vals.indexOf(string);
   return index>-1?Object.keys(messages)[index]:false;
}